<template>
  <div class="cityPartnerMore">
    <van-sticky>
      <div
        class="moreNav"
        :style="{ 'padding-top': (isiOSX ? 44 : 24) + 'px' }"
      >
        <img
          class="navLeft"
          @click="goBack()"
          src="./../../../assets/decoration/back.png"
        />
        <span class="navTitle">更多</span>
      </div>
    </van-sticky>
    <div class="content">
      <div class="top">
        <img src="./../../../assets/decoration/cityPartnerLogo.png" />
        <p>装饰合伙人</p>
        <!-- <p>v1.0</p> -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isiOSX: false,
    };
  },
  created() {
    this.isiOSX = this.isIphoneX();
  },
  mounted() {},
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    toPayFees() {
      this.$router.push({
        path: "/decoration/deputy/payFees",
      });
    },
    toContractList() {
      this.$router.push({
        path: "/decoration/deputy/contractList",
      });
    },
  },
};
</script>
<style lang="less">
.cityPartnerMore {
  height: 100%;
  background: #f5f6ff;
  .moreNav {
    background: #f5f6ff;
    height: 44px;
    position: relative;
    .navLeft {
      width: 24px;
      height: 24px;
      position: absolute;
      left: 16px;
      bottom: 10px;
    }
    .navTitle {
      position: absolute;
      left: 50%;
      bottom: 10px;
      transform: translateX(-50%);
      font-size: 17px;
      font-weight: 700;
      color: #404247;
    }
  }
  .content {
    background: #ffffff;
    border-radius: 12px;
    margin: 16px;
    padding: 1px 24px 8px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    .top {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: 47px 0 47px;
      img {
        border-radius: 8px;
        width: 64px;
        height: 64px;
        border: 1px solid #f0f1ff;
      }
      p {
        font-size: 13px;
        color: #333333;
        line-height: 18px;
        margin: 12px 0 0;
      }
    }
    .item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px 0;
      margin-bottom: 20px;
      span {
        font-size: 15px;
        font-weight: 400;
        color: #333333;
        line-height: 21px;
      }
      img {
        width: 12px;
        height: 12px;
      }
    }
  }
}
</style>